/*

Poornima 09/19/2022 2701290703 Fixed GAL-127,132,73,60,104 bugs
Ashraf 09/23/2022 2701290703 fixed validation messages in record format
Sohel 10/06/2022 2701290703 Record Format ->Map Variables ->Search Table Payload Changes, Catagory Lookup and Fixed GAL- 406
Poornima 10/27/2022 2701290703 Added classnames and modified the text feilds as oer the new design.
*/

import {
  FormControl,
  Button,
  InputLabel,
  TextField,
  Select,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ResetStatus as resetStatus, getDropDownData} from '../../../../redux/reducers/BRE/AddRecordFormat';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import RecordFormatSearchTable from './RecordFormatSearchTable';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {FILE_TYPE} from '../../../../constants/Lookup';
import {getOptions} from '../../../../util/GetDropDownOptions';
import * as Yup from 'yup';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';

const SearchRecordFormat = ({
  setValue,
  setRecordFormatCode,
  formatType,
  setFormatType,
  setFieldListId,
  fieldListId,
  setIsCopyIcon,
  isCopyIcon,
  setNotesEnable,
  setRowSelected,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const types = [
    {key: 'Report Record Format', value: 'RecordFormat'},
    {key: 'Enable Record Format', value: 'Enable'},
  ];
  const schema = Yup.object().shape({
    code: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'Record Format Code cannot contain white space/special characters',
    ),
  });
  useEffect(() => {
    fieldListId && setFieldListId(null);
    dispatch(getDropDownData());
  }, []);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  const {searchRecordFormatFieldData, dropDownData} = useSelector(
    ({addRecordFormat}) => addRecordFormat,
  );

  useEffect(() => {
    dispatch(resetStatus());
    setValue(0);
  }, []);
  const initialValues = {
    code: '',
    description: '',
    formattype: formatType ? formatType : null,
    fileType: '',
  };
  const onClear = () => {
    const data = {
      code: '',
      description: '',
      formattype: 'RecordFormat',
      fileType: '',
    };
    setSearchData(data);
  };
  const handleSubmit = (data) => {
    setSearchFlag(true);
    setSearchData(data);
    setSubmit(true);
  };
  return (
    <div>
      <div className={` mb-0`}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              touched,
              errors,
              handleReset,
              handleBlur,
              setFieldValue,
              handleSubmit,
            } = props;

            return (
              <div>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div>
                    <ErrorBoundaryForComponents>
                      <div className="form-row global-field-textfields">
                        <div className="col-sm-6 col-md-2 form-group">
                          <TextField
                            margin="dense"
                            variant="standard"
                            placeholder={`Enter Record Format Code`}
                            label="Record Format Code"
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            name="code"
                            value={values?.code?.toUpperCase()}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.code}
                            error={Boolean(touched.code && errors.code)}
                          />
                          <FormHelperText>
                            {touched.code && errors.code && errors.code}
                          </FormHelperText>
                        </div>
                        <div className="col-sm-6 col-md-4 form-group">
                          <TextField
                            margin="dense"
                            variant="standard"
                            placeholder={`Enter Record Format Description`}
                            label="Record Format Description"
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </div>
                        {!(Object.keys(searchRecordFormatFieldData).length > 0) && (
                          <div
                            className={`col-sm-6 col-md-2 form-group ${classes.selectdropdown}`}
                          >
                            <FormControl margin="dense" fullWidth>
                              <InputLabel>Record Format Type</InputLabel>
                              <Select
                                fullWidth
                                variant="standard"
                                value={values.formattype}
                                onChange={(e) => {
                                  setFieldValue('formattype', e.target.value);
                                  setFormatType(e.target.value);
                                  handleChange;
                                }}
                                className="select-gender"
                                name="formattype"
                                label="Record Format Type"
                              >
                                <MenuItem value="none" key="none" disabled>
                                  <span className="defaultSelected">Select Record Format Type</span>
                                </MenuItem>
                                {types.map((option) => {
                                  return (
                                    <MenuItem value={option.value} key={option.key}>
                                      {option.key}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </div>
                        )}

                        <div className={`col-sm-6 col-md-2 form-group ${classes.selectdropdown}`}>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="fileType"
                            id="fileType"
                            size="small"
                            value={values.fileType}
                            options={getOptions(FILE_TYPE, dropDownData)}
                            getOptionLabel={(option) => (option?.value ? option?.value : '')}
                            required
                            onChange={(e, value) => {
                              handleChange(e);
                              setFieldValue('fileType', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="standard"
                                  margin="dense"
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  label="File Type"
                                  placeholder="Select File Type"
                                />
                              </div>
                            )}
                          />
                        </div>
                        <div className={`col-sm-6 col-md-2 form-group d-flex align-items-center justify-content-end`}>
                          <Button
                            variant="outlined"
                            className={`reset-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              handleReset();
                              onClear();
                              setSubmit(true);
                              setFormatType('RecordFormat');
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            color="primary"
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </ErrorBoundaryForComponents>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
        <RecordFormatSearchTable
          setValue={setValue}
          setRecordFormatCode={setRecordFormatCode}
          searchData={searchData}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          searchFlag={searchFlag}
          submit={submit}
          setSubmit={setSubmit}
          formatType={formatType}
          setIsCopyIcon={setIsCopyIcon}
          isCopyIcon={isCopyIcon}
          setNotesEnable={setNotesEnable}
          setRowSelected={setRowSelected}
        />
      </div>
    </div>
  );
};

export default SearchRecordFormat;
